// extracted by mini-css-extract-plugin
export default {"wrapper":"Forbidden-module__wrapper--e8b43","header":"Forbidden-module__header--ac995","fields":"Forbidden-module__fields--c57ff","buttons":"Forbidden-module__buttons--f642b"};